import axios from '@/plugins/axios'
import { Message } from 'element-ui'
const OSS = require('ali-oss')
// 桶配置
export const bucketConfig = {
  'hys-good-skus': 'hys-good-skus' /* 商品： */,
  'hys-cualifications': 'hys-cualifications' /* 资质： */,
  'hys-basedata': 'hys-basedata' /* 其他： */,
}
// 桶配置对应域名
const bucketConfigUrl = {
  'hys-good-skus': 'skupic.yaoyueyue.com' /* 商品： */,
  'hys-cualifications': '' /* 资质： */,
  'hys-basedata': 'pic.yaoyueyue.com' /* 其他： */,
}
// 图片上传
async function upLoad(client, file, bucket, userId) {
  try {
    let ext = file.file.name.slice(file.file.name.indexOf('.'))
    let date = new Date()
    let nowMonth = date.getMonth() + 1
    let strDate = date.getDate()
    let name = `${nowMonth > 9 ? nowMonth : '0' + nowMonth}/${
      strDate > 9 ? strDate : '0' + strDate
    }/${userId}${Date.parse(new Date())}${ext}`

    let result = await client.put(name, file.file)
    let index = name.indexOf('.')
    let name_s = name.slice(0, index) + '_s' + name.slice(index)

    let psuhResult = client.processObjectSave(
      name,
      name_s,
      'style/default',
      bucket
    )
    // Message.success('图片上传OSS成功')
    return bucketConfigUrl[bucket]
      ? result.url.replace(
          /^http:\/\/[^/]+/,
          `http://${bucketConfigUrl[bucket]}`
        )
      : result.url
  } catch (e) {
    Message.error('图片上传OSS失败')
    return ''
  }
}
export const oss = function(
  fn,
  file,
  bucket = bucketConfig['hys-cualifications'],
  userId
) {
  return new Promise((resolve, reject) => {
    try {
      fn('/api/oss/config', {
        bucket,
      }).then((resp) => {
        let client = new OSS(resp.data)
        let url = upLoad(client, file, bucket, userId)
        url ? resolve(url) : reject()
      })
    } catch (error) {
      console.log(error)
    }
  })
}
